import { useProjectId } from "../../shopdrawing/ProjectName";
import { QuoteSwitcher } from "../pricing/QuoteSwitcher";
import { jsx as _jsx } from "react/jsx-runtime";
export function Div10Switcher() { const projectId = useProjectId(); return /*#__PURE__*/ _jsx(QuoteSwitcher, { title: "Div 10", url: `/project/${projectId}/shop-drawing/div10`, quoteTitle: "Quote Div 10", quoteURL: `/project/${projectId}/quote/-1/div-10` }); }
